
<form @submit.prevent="search">
  <fieldset>
    <div class="field dropdown is-active">
      <div class="dropdown-trigger">
        <div class="field has-addons">
          <div class="control is-expanded has-icons-left">
            <input v-model="query" :class="{ 'is-danger': error }" class="input" type="search" :placeholder="inputPlaceholder" />
            <span class="icon is-left">
              <img class="location-svg pr-2" src="@/images/header/crosshairs-gps.svg" alt="Use current location">
            </span>
          </div>
          <div class="control">
            <div v-if="error">
              <button @click.prevent="resetSearch()" class="button  search-btn">
                Reset
              </button>
            </div>
            <div v-else class="search-btn-container">
              <button :class="{ 'is-loading': loading }" :disabled="isButtonDisabled" type="submit" class="button search-btn">
                <p style="font-size: 12px;">{{ submitLabel }}</p>
              </button>
            </div>
          </div>
        </div>

        <div v-if="error" class="help" :style="errorStyle">
          {{ error }}
          <b><a @click.prevent="resetSearch()">Try Again</a></b>
        </div>
      </div>
      <div v-if="!coordinates && cities.length" class="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <p class="dropdown-item"><b>We found mulitple results...</b></p>
          <a v-for="city in cities" :key="city.id" :href="getPath(city.node)" class="dropdown-item">
            {{ city.node.name }}, {{ city.node.stateId | upcase }}
          </a>
        </div>
      </div>
    </div>
    <geolocate @success="searchByCoordinates" v-if="showSearchByGeolocate" />
  </fieldset>
</form>
